import { render, staticRenderFns } from "./PageStatsMain.vue?vue&type=template&id=ea2f9aca&"
import script from "./PageStatsMain.vue?vue&type=script&lang=js&"
export * from "./PageStatsMain.vue?vue&type=script&lang=js&"
import style0 from "./PageStatsMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports